var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.05,
    height: 160.807,
    viewBox: "0 0 145.05 160.807",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-_1_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_177",
    "data-name": "Path 177",
    d: "M161.28-511.636A42.546,42.546,0,0,0,136.165-499.9a41.408,41.408,0,0,0-3.832,55.6,42.242,42.242,0,0,0,53.808,10.6,41.738,41.738,0,0,0,20.554-44.238,42.312,42.312,0,0,0-32.842-32.974A58.431,58.431,0,0,0,161.28-511.636Z",
    transform: "translate(-92.872 511.745)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_178",
    "data-name": "Path 178",
    d: "M65.638-236.051a53.078,53.078,0,0,0-34.9,23.472C29.059-209.968,27-205.531,27-204.493c0,2.077,6.017,10.509,11.718,16.393a83.49,83.49,0,0,0,50.831,25.391,123.968,123.968,0,0,0,19.636,0,84.468,84.468,0,0,0,42.6-17.777A112.273,112.273,0,0,0,166.1-195.148c3.325-4.436,5.954-8.653,5.954-9.628,0-.944-1.774-4.814-3.325-7.205a54.937,54.937,0,0,0-21.409-19.445c-6.176-3.052-13.872-5.16-17.767-4.877a6.816,6.816,0,0,0-3.484,1.2,55.173,55.173,0,0,1-8.551,4.751,43.642,43.642,0,0,1-19.572,3.65,44.036,44.036,0,0,1-23.4-7.457A22.119,22.119,0,0,0,70.8-236.24c-.507-.094-1.108-.22-1.362-.283A24.538,24.538,0,0,0,65.638-236.051Z",
    transform: "translate(-27 323.126)",
    fill: "#707070"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.811f1a3764af5d9cfc2d4aef8b9683cb.svg";
export { ForwardRef as ReactComponent };